<template>
	<div class="col-12 col-lg-4">
		<b-form-group id="example-input-group-6">
			<label
				for="example-input-group-6"
				class="d-block col-form-label-sm"
			>
				{{ options.description }}
			</label>
			<b-form-checkbox
				switch
				class="mt-2 pb-1 border-bottom"
				:checked="actualValue"
				@input="change"
			>
				{{ field.name }}
			</b-form-checkbox>
			<div v-if="isValidate === false" class="error">
				Заполните поле
			</div>
		</b-form-group>
	</div>
</template>

<script>
export default {
	name: 'Checkbox',
	props: {
		field: {
			type: Object,
			default: () => {},
		},
		value: { default: null },
	},
	data() {
		return {
			isValidate: null,
			actualValue: this.value == 0 || this.value === 'false' ? false : Boolean(this.value),
		};
	},
	computed: {
		options() {
			if (this.field?.options || null) {
				return JSON.parse(this.field?.options);
			}

			return {};
		},
		required() {
			if (!this.field?.validations) {
				return false;
			}
			const validations = JSON.parse(this.field?.validations);
			return Object.keys(validations).includes('required');
		},
	},
	methods: {
		change(val) {
			this.actualValue = Boolean(val);
			this.$emit('input', this.actualValue);
			this.$emit('change', this.actualValue);
			this.$emit('blur', this.actualValue);
		},
		checkValidation() {
			this.isValidate = true;
			if (this.required) {
				this.isValidate = this.actualValue;
			}
			return this.isValidate;
		},
	},

};
</script>

<style scoped>
.error {
	width: 100%;
	margin-top: 0.25rem;
	font-size: 80%;
	color: #dc3545;
}
</style>
